import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledSend = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.disabled {
    .cls-2 {
      fill: var(--du-color-grey, #969696);
      stroke: var(--du-color-grey, #969696);
    }
  }

  &: hover, &.active {
    &:not([disabled]) {
      .cls-2 {
        fill: var(--du-color-primary, #128370);
      }
    }
  }
`;

const FooterSendIcon: React.FC<IconProps> = ({ active, disabled }) => {
  const activeclass = disabled ? 'disabled' : active ? 'active' : undefined;
  return (
    <StyledSend
      id='icon_outlined_directional_arrow-up'
      data-name='icon/outlined/directional/arrow-up'
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      className={activeclass}
      disabled={disabled}
    >
      <path
        id='icon_outlined_directional_arrow-up_clip_mask_'
        data-name='icon/outlined/directional/arrow-up (clip mask)'
        d='M4,0H18a4,4,0,0,1,4,4V18a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z'
        transform='translate(1 1)'
        fill='#525252'
      />
      <rect
        id='icon_outlined_directional_arrow-up_clip_mask_2'
        data-name='icon/outlined/directional/arrow-up (clip mask)'
        width='24'
        height='24'
        fill='none'
      />
      <g id='Group_363' data-name='Group 363'>
        <g
          id='icon_outlined_directional_arrow-up_clip_group_'
          data-name='icon/outlined/directional/arrow-up (clip group)'
        >
          <rect
            id='icon_outlined_directional_arrow-up_style_'
            data-name='icon/outlined/directional/arrow-up (style)'
            width='24'
            height='24'
            fill='none'
          />
          <path
            id='Vector'
            d='M15.338,8.454,8.208.237a.687.687,0,0,0-1.038,0L.042,8.454a.171.171,0,0,0,.129.284h1.74a.348.348,0,0,0,.26-.118l4.7-5.42V15.3a.172.172,0,0,0,.172.172H8.334a.172.172,0,0,0,.172-.172V3.2l4.7,5.42a.341.341,0,0,0,.26.118h1.74A.171.171,0,0,0,15.338,8.454Z'
            transform='translate(4.31 4.266)'
            fill='#fff'
          />
        </g>
      </g>
    </StyledSend>
  );
};

export default FooterSendIcon;
